import React, {Component} from "react"

import id from "@irati/utils/id"
import History from "@irati/utils/history"
import Form from "@irati/ui/src/Form"
import Input from "@irati/ui/src/FormItem/Input"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import Loading from "@irati/ui/src/Loading"
import Validation from "@irati/utils/validation"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import Link from "@irati/ui/src/Link"
import globalLoginService from "@irati/auth/services/globalLogin"
import {Body, H3} from "@irati/ui/src/Typography"

import LoginBlock from "../../../components/LoginBlock"
import LoginBackground from "../../../components/LoginBackground"

interface Props extends InjectIntl {}

interface State {
  submit: Promise<any> | null
  email: string
}

class ForgotDomain extends Component<Props, State> {
  state: State = {
    email: "",
    submit: null
  }

  handleEmailSubmit = () => {
    const {email} = this.state

    const submit = globalLoginService.forgotSubdomain(email).then(() => {
      return History.push({
        pathname: "/welcome/login/check-email",
        subdomain: true,
        email
      })
    })

    this.setState({submit})
  }

  emailValidation = () => {
    const schema = Validation.string("platform.defaultLogin.fields.emailValidation.enterEmail")
    return schema.email("platform.defaultLogin.fields.emailValidation.notValid")
  }

  updateEmail = (email: string) => {
    this.setState({email, submit: null})
  }

  handleBack = () => History.push("/welcome/login")

  render() {
    const {submit} = this.state
    const {formatMessage} = this.props

    const idNamespace = id("global-login", this.props)
    const helpLinks = [
      <Link href={formatMessage({id: "platform.globalLogin.fields.subdomainFinder.helpLinkUrl"})} target="_blank">
        <FormattedMessage id="platform.globalLogin.subdomain.help.whatIsDomain.text" />
      </Link>
    ]

    return (
      <LoginBackground>
        <LoginBlock id={idNamespace} helpLinks={helpLinks} hideTitle onBack={this.handleBack}>
          <H3 id={id("title", idNamespace)} marginBottom={2} textAlign="center">
            <FormattedMessage id="platform.globalLogin.fields.subdomainFinder.mainHeader" />
          </H3>
          <Body small marginBottom={2} textAlign="center" maxWidth="100%">
            <FormattedMessage id="platform.globalLogin.fields.subdomainFinder.body" />
          </Body>
          <Form form="global-login">
            <Input
              id={id("field-email", idNamespace)}
              className="field-email"
              label={formatMessage({id: "platform.globalLogin.fields.email.label"})}
              name="email"
              type="email"
              value={this.state.email}
              placeholder={formatMessage({id: "platform.globalLogin.fields.email.placeholder"})}
              onChange={(value: string) => this.updateEmail(value)}
              onEnter={() =>
                Validation.validate()
                  .then(this.handleEmailSubmit)
                  .catch(() => {})
              }
              validation={this.emailValidation()}
            />
            <Loading id={id("submit-response", idNamespace)} load={submit} useLoader={false} />
            <ValidationButton id={id("btn-submit", idNamespace)} primary full load={submit} onClick={this.handleEmailSubmit}>
              <FormattedMessage id="platform.globalLogin.fields.subdomainFinder.continue" />
            </ValidationButton>
          </Form>
        </LoginBlock>
      </LoginBackground>
    )
  }
}

export default injectIntl(ForgotDomain)
